<template>
    <div class="browse-history">
        <section class="top-wrapper">
            <el-date-picker
                v-model="dateValue"
                :class="['date-picker', {'date-init': !dateValue }]"
                popper-class="date-picker-pop"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="-"
                start-placeholder="如：2019-01-30 至 2019-01-30"
                end-placeholder=""
                :picker-options="pickerOptions">
            </el-date-picker>
            <el-popover
                placement="top"
                width="288"
                trigger="click"
                title="确认清空所有浏览历史？"
                popper-class="clear-history-pop">
                <p class="pop-content">清空后，将无法恢复，请谨慎操作</p>
                <div style="text-align: right; margin: 0">
                    <el-button type="primary" size="mini" @click="handleClearAllBrowse">清空</el-button>
                    <el-button size="mini" @click="visible = false">取消</el-button>
                </div>
                <p slot="reference" class="clear-btn">清空所有历史</p>
            </el-popover>
        </section>
        <section class="bottom-wrapper" v-loading="historyLoading">
            <template v-if="historyList.length">
                <ul>
                    <li class="history-item" v-for="(historyItem, index) in historyList" :key="index">
                        <dl class="history-content">
                            <dt>
                                <span>{{ historyItem.label }}</span>
                            </dt>
                            <dd
                                v-for="(item, cIndex) in historyItem.items"
                                :key="cIndex"
                                :class="{'is-delete': item.is_deleted}"
                                @click="handleSkip(item)">
                                <span class="circle"></span>
                                <span class="time">{{ item.browse_time }}</span>
                                <p class="title">{{ item.instance_title }}</p>
                                <span class="delete" v-if="item.is_deleted">已删除</span>
                                <el-tooltip effect="dark" content="清空" placement="top">
                                    <i class="clear" @click.stop="handleClearBrowse(item)"></i>
                                </el-tooltip>
                            </dd>
                        </dl>
                    </li>
                </ul>
            </template>
            <template v-else-if="!historyLoading">
                <div class="data-null">
                    <img src="../../images/personal_center/data-null.png" alt="">
                    <p>没有数据</p>
                </div>
            </template>
            <div class="load-more" v-if="isMoreLoading">
                <img v-if="isMoreLoading" alt="loading" src="../../images/common/loading_2_24x24.gif">
                <span v-else>{{ !isPageOver ? '显示更多' : '没有更多内容了' }}</span>
            </div>
        </section>
    </div>
</template>

<script>
    import personalCenter from '@/mixins/personalCenter.js'
    export default {
        mixins: [ personalCenter ],
        data () {
            return {
                dateValue: '',
                visible: false,
                curPage: 1,
                historyList: [],
                historyLoading: false,
                isMoreLoading: false,
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick (picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    }, {
                        text: '最近一个月',
                        onClick (picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    }, {
                        text: '最近三个月',
                        onClick (picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }]
                }
            }
        },
        watch: {
            dateValue (val) {
                this.curPage = 1
                this.getHistoryList()
            }
        },
        created () {
            this.getHistoryList()
        },
        methods: {
            // 获取任务记录列表
            getHistoryList (more) {
                try {
                    if (this.historyLoading || this.isMoreLoading) return
                    if (more) {
                        this.isMoreLoading = true
                    } else {
                        this.historyLoading = true
                    }
                    const gteTime = this.dateValue[0] ? this.handleFormat(this.dateValue[0]) : undefined
                    const lteTime = this.dateValue[1] ? this.handleFormat(this.dateValue[1]) : undefined
                    axios.get(myUrl + 'history_browse/api/', {
                        params: {
                            page_size: 20,
                            page: this.curPage,
                            browse_time__gte: gteTime,
                            browse_time__lte: lteTime ? (lteTime.split(' ')[0] + ' 23:59:59') : undefined
                        }
                    }).then(res => {
                        const resp = res.data.data
                        const historyList = more ? this.historyList : []
                        resp.results.forEach(item => {
                            const length = historyList.length
                            const last = historyList[length - 1]
                            const date = item.browse_time
                            item.browse_date = item.browse_time.split(' ')[0]
                            item.browse_time = item.browse_time.split(' ')[1].slice(0, 5)
                            if (last && item.browse_date === last.browse_date) {
                                last.items.push(item)
                            } else {
                                const browseDate = this.handleTime(date)
                                historyList.push({
                                    label: browseDate,
                                    browse_date: item.browse_date,
                                    items: [item]
                                })
                            }
                        })
                        if (!more) {
                            this.historyList = historyList
                        }
                        // 是否可以加载更多
                        this.totalPage = Math.ceil(resp.count / 20)
                        this.isPageOver = this.curPage >= this.totalPage
                    })
                } catch (error) {
                    console.warn(error)
                } finally {
                    this.isMoreLoading = false
                    this.historyLoading = false
                }
            },
            // 清空所有
            handleClearAllBrowse () {
                try {
                    axios.delete(myUrl + 'history_browse/api/clear/').then(res => {
                        this.historyList = []
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        })
                    })
                } catch (error) {
                    console.warn(error)
                }
            },
            // 调整帖子详情
            handleSkip (info) {
                const type = info.browse_type === 'qa' ? 'answer' : 'article'
                let routeData = this.$router.resolve({
                    name: 'Question',
                    params: {
                        wid: info.instance_id
                    },
                    query: {
                        type
                    }
                })
                window.open(routeData.href, '_blank')
            },
            // 清空单条记录
            handleClearBrowse (info) {
                try {
                    const { browse_date, id } = info
                    axios.delete(myUrl + `history_browse/api/${id}/`).then(res => {
                        const dateIndex = this.historyList.findIndex(item => item.browse_date === browse_date)
                        const dayList = this.historyList[dateIndex].items
                        const timeIndex = dayList.findIndex(item => item.id === id)
                        dayList.splice(timeIndex, 1)
                        if (!dayList.length) {
                            this.historyList.splice(dateIndex, 1)
                        }
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        })
                    })
                } catch (error) {
                    console.warn(error)
                }
            },
            // 监听滚动
            handleScroll () {
                // 滚动加载
                this.scrollLoading(this.getHistoryList, false)
            },
            // 处理时间
            handleTime( time ){
                let ptime = new Date(time).getTime()
            
                const twentyFourHours = 24 * 60 * 60 * 1000
                const fortyEightHours = 24 * 60 * 60 * 1000 * 2
                const date = new Date()
                const year = date.getFullYear()
                const month = date.getMonth() + 1
                const day = date.getDate()
                const today = `${year}-${month}-${day}` 
                const todayTime = new Date(today).getTime()
                const yesterdayTime = new Date(todayTime - twentyFourHours).getTime()
                const lastYesterdayTime = new Date(todayTime - fortyEightHours).getTime()

                if ( ptime >= todayTime ){
                    return '今天 '
                }
                else if ( ptime < todayTime && yesterdayTime <= ptime ){
                    return '昨天 '
                }
                else if ( ptime < yesterdayTime && lastYesterdayTime <= ptime ){
                    return '前天 '
                }
                else {
                    return time.split(' ')[0]
                }
            },
            handleFormat (date) {
                date = date || new Date()
                const year = date.getFullYear();
                const month = change(date.getMonth() + 1)
                const day = change(date.getDate())
                const hour = change(date.getHours())
                const minute = change(date.getMinutes())
                const second = change(date.getSeconds())
                function change(t) {
                    if (t < 10) {
                        return "0" + t
                    } else {
                        return t
                    }
                }
                const time = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
                return time
            }
        }
    }
</script>

<style lang="scss">
    .clear-history-pop {
        padding: 16px 24px;
        box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.16);
        .el-popover__title {
            color: #313238;
            margin-bottom: 12px;
        }
        .pop-content {
            font-size: 12px;
            color: #63656e;
            margin-bottom: 16px;
        }
        .el-button {
            width: 48px;
            height: 26px;
            padding: 0;
            background: #fff;
            border-color: #c4c6cc;
            color: #63656e;
            &:hover {
                border-color: #979ba5;
                color: #63656e;
            }
            &.el-button--primary {
                color: #fff;
                background: #3a84ff;
                border-color: #3a84ff;
                &:hover {
                    background: #699df4;
                    border-color: #699df4;
                }
            }
        }
    }
    .date-picker-pop {
        .el-date-range-picker__header > div {
            font-size: 14px;
        }
        .el-picker-panel__sidebar {
            right: 0;
            .el-picker-panel__shortcut {
                font-size: 12px;
                &:hover {
                    color: #3a84ff;
                }
            }
        }
        .el-picker-panel__body {
            margin: 0 110px 0 0;
            .el-picker-panel__content {
                border-right: 1px solid #e4e4e4;
            }
        }
    }
    .date-picker {
        height: 32px;
        width: 300px !important;
        border-color: #c4c6cc;
        border-radius: 2px;
        .el-input__icon {
            line-height: 25px;
        }
        .el-range-input {
            width: 25%;
            font-size: 12px;
            text-align: left;
        }
        .el-range-separator {
            width: 2%;
            line-height: 24px;
            padding: 0;
            margin: 0 5px 0 3px;
        }
        &.date-init {
            .el-range-separator {
                display: none;
            }
            input:nth-of-type(1) {
                width: 65%;
            }
            input:nth-of-type(2) {
                display: none;
            }
        }
    }
    
</style>
<style lang="scss" scoped>
    .browse-history {
        width: 1200px;
        margin: 0 auto;
        background: #fff;
        padding: 24px;
        .top-wrapper {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            margin-bottom: 24px;
            .clear-btn {
                color: #3a84ff;
                line-height: 19px;
                cursor: pointer;
            }
        }
        .bottom-wrapper {
             min-height: 200px;
            .history-item {
                .history-content {
                    color: #63656e;
                    margin-bottom: 31px;
                    dt {
                        color: #313238;
                        font-weight: 700;
                        padding-left: 8px;
                        margin-bottom: 11px;
                    }
                    dd {
                        height: 40px;
                        display: flex;
                        align-items: center;
                        position: relative;
                        line-height: 40px;
                        padding: 0 12px 0 11px;
                        margin-bottom: 11px;
                        cursor: pointer;
                        .circle {
                            height: 4px;
                            width: 4px;
                            border-radius: 50%;
                            background: #63656e;
                        }
                        .time {
                            margin-left: 10px;
                        }
                        .title {
                            margin-left: 16px;
                            max-width: 900px;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space:nowrap;
                        }
                        .delete {
                            display: none;
                            width: 58px;
                            height: 22px;
                            text-align: center;
                            line-height: 22px;
                            font-size: 12px;
                            color: #ea3536;
                            background: #feebea;
                            border-radius: 2px;
                            margin-left: 10px;
                        }
                        .clear {
                            position: absolute;
                            right: 12px;
                            top: 13px;
                            height: 14px;
                            width: 14px;
                            background: url('../../images/personal_center/close1.png');
                            background-size: 100% 100%;
                            &::after {
                                content: '';
                                height: 14px;
                                width: 14px;
                                position: absolute;
                                background: url('../../images/personal_center/close2.png');
                                background-size: 100% 100%;
                                display: none;
                            }
                            &:hover {
                                &::after {
                                    display: block;
                                    z-index: 3;
                                }
                            }
                        }
                        &:hover {
                            background: #f5f7fa;
                        }
                        &.is-delete {
                            .title {
                                opacity: 0.4;
                            }
                            .delete {
                                display: block;
                            }
                        }
                    }
                }
            }
            .data-null {
                padding: 50px 0 20px;
                width: 100%;
                text-align: center;
                color: #63656e;
                img {
                    width: 120px;
                    height: 100px;
                    margin-bottom: 10px;
                }
            }
            .text-blue {
                color: #3a84ff;
            }
        }
        .el-loading-mask {
            background-color: rgba($color: #fff, $alpha: 1.0);
        }
    }
</style>


// WEBPACK FOOTER //
// history.vue?7f4738bf